import React, { useEffect, useState } from "react";

//
import Api from "./api";
import CourseProvider from "../../../context/course/CourseProvider";

//
const initialState = {
  courses: [],
  course: null,
  loading: false,
};

export default function Course({ children }) {
  // state
  const [state, setState] = useState({ ...initialState });

  // lifecycle
  useEffect(() => {
    getAllCourses();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // method
  function changeCourses(courses) {
    setState((p) => ({
      ...p,
      courses,
    }));
  }

  function changeOneCourse(course) {
    setState((p) => ({
      ...p,
      course,
    }));
  }

  function changeLoading(loading) {
    setState((p) => ({
      ...p,
      loading,
    }));
  }

  async function getAllCourses() {
    changeLoading(true);
    try {
      const { data } = await Api.getAll();
      changeCourses([...data]);
    } catch (error) {
      console.error(error);
      changeCourses([]);
    } finally {
      changeLoading(false);
    }
  }

  async function getOneCourse(body) {
    changeLoading(true);
    try {
      const { data } = await Api.getOne(body.id);
      changeOneCourse(data);
    } catch (error) {
      console.error(error);
      changeOneCourse(null);
    } finally {
      changeLoading(false);
    }
  }

  return <CourseProvider value={{ state, fn: { getOneCourse } }}>
    {children}
  </CourseProvider>;
}
